module.exports = __webpack_public_path__ + "static/media/CSGEA-2022-Gold-PNG-1.cea998e0.png";